(function () {
  var ROOT = document.getElementById('sk-advocacy-contact');
  if (!ROOT) return;

  var DATA_URL = ROOT.getAttribute('data-json');
  var LOOKUP_URL = ROOT.getAttribute('data-lookup') || 'https://aspireweb.net/sk-reps/index.php';
  var HOUSE_FIND = 'https://www.house.gov/representatives/find-your-representative';

  var DEFAULT_LETTER =
    'Subject: Support responsible low-strength hemp beverages for adults\n\n' +
    'Dear [Representative/Senator],\n\n' +
    'I am writing as a constituent who supports responsible, adult-only access to low-strength hemp-derived beverages.\n\n' +
    'Please support policies that:\n' +
    '1. Keep naturally occurring hemp cannabinoids available for adults 21+ in states where they are legal.\n' +
    '2. Require honest milligram labeling and third-party lab testing.\n' +
    '3. Keep these products out of the hands of kids through age verification and packaging that does not target minors.\n' +
    '4. Distinguish responsible Farm Bill products from synthetic or gray-area formulations, instead of blanket bans that punish compliant brands and retailers.\n\n' +
    'Low-strength hemp drinks (typically 10mg THC per serving or less) are already enjoyed by millions of adults. Clear standards protect consumers better than wiping out the legal category.\n\n' +
    'Thank you for your time and consideration.\n\n' +
    'Sincerely,\n' +
    '[Your name]\n' +
    '[City, State ZIP]';

  var data = null;
  var statusEl = ROOT.querySelector('[data-status]');
  var resultsEl = ROOT.querySelector('[data-results]');
  var letterEl = ROOT.querySelector('[data-letter]');
  var zipEl = ROOT.querySelector('[data-zip]');
  var findBtn = ROOT.querySelector('[data-find]');

  if (letterEl && !letterEl.value) letterEl.value = DEFAULT_LETTER;

  function setStatus(msg, isError) {
    if (!statusEl) return;
    statusEl.textContent = msg || '';
    statusEl.classList.toggle('is-error', !!isError);
  }

  function escapeHtml(s) {
    return String(s || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function memberCard(m, role) {
    var contact = m.contact || m.url || '';
    var phone = m.phone ? '<p class="sk-rep__meta">' + escapeHtml(m.phone) + '</p>' : '';
    var party = m.party ? ' · ' + escapeHtml(m.party) : '';
    var links = '';
    if (contact) {
      links +=
        '<a class="btn btn--primary btn--small" href="' +
        escapeHtml(contact) +
        '" target="_blank" rel="noopener">Open contact form</a>';
    } else if (m.url) {
      links +=
        '<a class="btn btn--primary btn--small" href="' +
        escapeHtml(m.url) +
        '" target="_blank" rel="noopener">Official website</a>';
    }
    links +=
      '<button type="button" class="btn btn--ghost btn--small" data-copy-letter>Copy letter</button>';
    return (
      '<article class="sk-rep">' +
      '<h4 class="sk-rep__name">' +
      escapeHtml(m.name) +
      '</h4>' +
      '<p class="sk-rep__role">' +
      escapeHtml(role) +
      party +
      '</p>' +
      phone +
      '<div class="sk-rep__actions">' +
      links +
      '</div>' +
      '</article>'
    );
  }

  function render(state, district) {
    if (!data) return;
    var html = '';
    var sens = (data.senators && data.senators[state]) || [];
    sens.forEach(function (s) {
      html += memberCard(s, 'U.S. Senate · ' + state);
    });
    var house = null;
    if (district != null && district !== '') {
      house = data.house[state + '-' + String(district)];
    }
    if (house) {
      html += memberCard(
        house,
        'U.S. House · ' + state + '-' + district
      );
    } else {
      html +=
        '<article class="sk-rep sk-rep--muted">' +
        '<h4 class="sk-rep__name">Your House member</h4>' +
        '<p class="sk-rep__role">We could not auto-match a district for this ZIP (some ZIPs cross district lines).</p>' +
        '<div class="sk-rep__actions">' +
        '<a class="btn btn--primary btn--small" href="' +
        HOUSE_FIND +
        '" target="_blank" rel="noopener">Find your House member</a>' +
        '<button type="button" class="btn btn--ghost btn--small" data-copy-letter>Copy letter</button>' +
        '</div></article>';
    }
    resultsEl.innerHTML = html || '<p>No members found for that ZIP.</p>';
    resultsEl.hidden = false;
  }

  function copyLetter() {
    var text = letterEl ? letterEl.value : DEFAULT_LETTER;
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(
        function () {
          setStatus('Letter copied. Paste it into your representative’s contact form.');
        },
        function () {
          setStatus('Select the letter and copy it manually (Ctrl/Cmd+C).', true);
        }
      );
    } else {
      letterEl.focus();
      letterEl.select();
      setStatus('Select the letter and copy it manually (Ctrl/Cmd+C).');
    }
  }

  resultsEl &&
    resultsEl.addEventListener('click', function (e) {
      var t = e.target;
      if (t && t.matches('[data-copy-letter]')) {
        e.preventDefault();
        copyLetter();
      }
    });

  function findReps() {
    var zip = (zipEl.value || '').replace(/\D/g, '');
    if (zip.length !== 5) {
      setStatus('Enter a valid 5-digit U.S. ZIP code.', true);
      return;
    }
    setStatus('Looking up your representatives…');
    resultsEl.hidden = true;
    fetch(LOOKUP_URL + '?zip=' + encodeURIComponent(zip), {
      credentials: 'omit',
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (res) {
        if (!res || !res.ok || !res.state) {
          throw new Error((res && res.error) || 'Lookup failed');
        }
        setStatus(
          'Showing members for ZIP ' +
            zip +
            ' (' +
            res.state +
            (res.district ? ' district ' + res.district : '') +
            '). Edit the letter, copy it, then open each contact form.'
        );
        render(res.state, res.district);
      })
      .catch(function (err) {
        setStatus(
          (err && err.message) ||
            'Lookup failed. You can still copy the letter and use the Find Your House Member link.',
          true
        );
        resultsEl.innerHTML =
          '<article class="sk-rep sk-rep--muted">' +
          '<div class="sk-rep__actions">' +
          '<a class="btn btn--primary btn--small" href="' +
          HOUSE_FIND +
          '" target="_blank" rel="noopener">Find your House member</a>' +
          '<button type="button" class="btn btn--ghost btn--small" data-copy-letter>Copy letter</button>' +
          '</div></article>';
        resultsEl.hidden = false;
      });
  }

  findBtn && findBtn.addEventListener('click', findReps);
  zipEl &&
    zipEl.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        findReps();
      }
    });

  fetch(DATA_URL, { credentials: 'omit' })
    .then(function (r) {
      return r.json();
    })
    .then(function (json) {
      data = json;
    })
    .catch(function () {
      setStatus('Could not load representative directory. Refresh and try again.', true);
    });
})();
